// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.settings-modal_modal-content_TXZjR {
    max-width: 750px;
}

.settings-modal_body_In07M {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
    min-height: 150px;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
}

/* For small screens, such as in the embed */

@media (max-height: 600px) {
    .settings-modal_modal-content_TXZjR {
        margin: 50px auto;
    }
    .settings-modal_body_In07M {
        max-height: calc(100vh - 150px);
    }
}

.settings-modal_setting_NH7nd {
    display: flex;
    flex-direction: column;
    padding: 0.5rem 1rem;
    margin: 0.25rem 0;
    border-radius: 4px;
}

.settings-modal_setting_NH7nd.settings-modal_active__g3gR {
    background: var(--badge-background);
}

.settings-modal_setting_NH7nd:hover,
.settings-modal_setting_NH7nd:focus-within {
    background: var(--badge-border);
}

.settings-modal_label_xt3GV {
    height: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.settings-modal_setting_NH7nd table {
    border-collapse: collapse;
}

.settings-modal_setting_NH7nd tr,
.settings-modal_setting_NH7nd td,
.settings-modal_setting_NH7nd th {
    padding: 0;
    margin: 0;
    border: 1px solid var(--ui-tertiary);
}

.settings-modal_checkbox_b886x {
    margin-right: 0.5rem;
}

.settings-modal_help-icon_st5nM {
    position: relative;
    border: 0;
    background-color: transparent;
    width: 20px;
    height: 20px;
    background-size: 100%;
    margin-left: 0.5rem;
    cursor: pointer;
}

.settings-modal_help-icon_st5nM img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: var(--filter-icon-black);
}

.settings-modal_custom-fps_o4HKh > * {
    margin-right: 0.5rem;
}

.settings-modal_custom-fps-input_YXstN {
    width: 50px;
}

.settings-modal_stage-mode_yBYgE > * {
    margin-right: 0.5rem;
}

.settings-modal_custom-stage-size_EakvX > * {
    margin-right: 0.5rem;
}

.settings-modal_custom-stage-size-input_bPWaB {
    width: 80px;
}

.settings-modal_custom-cloud-var-server_hcItu > * {
    margin-right: 0.5rem;
}

.settings-modal_custom-cloud-var-server-input_OzAsG {
    width: 350px; /* todo: make input-adaptive width */
}

.settings-modal_info_K5LRo {
    margin-bottom: 0.25rem;
}

.settings-modal_header_GB6qm {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0.5rem 0 0 0;
    font-weight: bold;
}

.settings-modal_divider_Xifj4 {
    flex-grow: 1;
    margin-left: 1rem;
    border-top: 1px dashed var(--ui-tertiary);
}

.settings-modal_button_iwiuL {
    font-family: inherit;
    font-size: 14px;
    background-color: var(--looks-secondary);
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    margin: 0;
    border-radius: 4px;
    cursor: pointer;
    font-family: inherit;
    font-weight: bold;
}

.settings-modal_button_iwiuL:active, .settings-modal_button_iwiuL:focus-within {
    box-shadow: 0 0 0 3px var(--looks-transparent);
}

.settings-modal_warning_v4b0C {
    padding: 0.5rem 1rem;
    margin: 0.25rem 0;
    border-radius: 4px;
    background: rgb(233, 233, 53);
    color: var(--text-primary-default);
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-settings-modal/settings-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,4CAA4C;;AAE5C;IACI;QACI,iBAAiB;IACrB;IACA;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,UAAU;IACV,SAAS;IACT,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY,EAAE,oCAAoC;AACtD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,wCAAwC;IACxC,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;AACtC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n    max-width: 750px;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n    min-height: 150px;\n    max-height: calc(100vh - 250px);\n    overflow-y: auto;\n}\n\n/* For small screens, such as in the embed */\n\n@media (max-height: 600px) {\n    .modal-content {\n        margin: 50px auto;\n    }\n    .body {\n        max-height: calc(100vh - 150px);\n    }\n}\n\n.setting {\n    display: flex;\n    flex-direction: column;\n    padding: 0.5rem 1rem;\n    margin: 0.25rem 0;\n    border-radius: 4px;\n}\n\n.setting.active {\n    background: var(--badge-background);\n}\n\n.setting:hover,\n.setting:focus-within {\n    background: var(--badge-border);\n}\n\n.label {\n    height: 32px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.setting table {\n    border-collapse: collapse;\n}\n\n.setting tr,\n.setting td,\n.setting th {\n    padding: 0;\n    margin: 0;\n    border: 1px solid var(--ui-tertiary);\n}\n\n.checkbox {\n    margin-right: 0.5rem;\n}\n\n.help-icon {\n    position: relative;\n    border: 0;\n    background-color: transparent;\n    width: 20px;\n    height: 20px;\n    background-size: 100%;\n    margin-left: 0.5rem;\n    cursor: pointer;\n}\n\n.help-icon img {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    filter: var(--filter-icon-black);\n}\n\n.custom-fps > * {\n    margin-right: 0.5rem;\n}\n\n.custom-fps-input {\n    width: 50px;\n}\n\n.stage-mode > * {\n    margin-right: 0.5rem;\n}\n\n.custom-stage-size > * {\n    margin-right: 0.5rem;\n}\n\n.custom-stage-size-input {\n    width: 80px;\n}\n\n.custom-cloud-var-server > * {\n    margin-right: 0.5rem;\n}\n\n.custom-cloud-var-server-input {\n    width: 350px; /* todo: make input-adaptive width */\n}\n\n.info {\n    margin-bottom: 0.25rem;\n}\n\n.header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 0.5rem 0 0 0;\n    font-weight: bold;\n}\n\n.divider {\n    flex-grow: 1;\n    margin-left: 1rem;\n    border-top: 1px dashed var(--ui-tertiary);\n}\n\n.button {\n    font-family: inherit;\n    font-size: 14px;\n    background-color: var(--looks-secondary);\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    margin: 0;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: inherit;\n    font-weight: bold;\n}\n\n.button:active, .button:focus-within {\n    box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.warning {\n    padding: 0.5rem 1rem;\n    margin: 0.25rem 0;\n    border-radius: 4px;\n    background: rgb(233, 233, 53);\n    color: var(--text-primary-default);\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `settings-modal_modal-content_TXZjR`;
export { _1 as "modal-content" };
export var modalContent = `settings-modal_modal-content_TXZjR`;
export var body = `settings-modal_body_In07M`;
export var setting = `settings-modal_setting_NH7nd`;
export var active = `settings-modal_active__g3gR`;
export var label = `settings-modal_label_xt3GV`;
export var checkbox = `settings-modal_checkbox_b886x`;
var _2 = `settings-modal_help-icon_st5nM`;
export { _2 as "help-icon" };
export var helpIcon = `settings-modal_help-icon_st5nM`;
var _3 = `settings-modal_custom-fps_o4HKh`;
export { _3 as "custom-fps" };
export var customFps = `settings-modal_custom-fps_o4HKh`;
var _4 = `settings-modal_custom-fps-input_YXstN`;
export { _4 as "custom-fps-input" };
export var customFpsInput = `settings-modal_custom-fps-input_YXstN`;
var _5 = `settings-modal_stage-mode_yBYgE`;
export { _5 as "stage-mode" };
export var stageMode = `settings-modal_stage-mode_yBYgE`;
var _6 = `settings-modal_custom-stage-size_EakvX`;
export { _6 as "custom-stage-size" };
export var customStageSize = `settings-modal_custom-stage-size_EakvX`;
var _7 = `settings-modal_custom-stage-size-input_bPWaB`;
export { _7 as "custom-stage-size-input" };
export var customStageSizeInput = `settings-modal_custom-stage-size-input_bPWaB`;
var _8 = `settings-modal_custom-cloud-var-server_hcItu`;
export { _8 as "custom-cloud-var-server" };
export var customCloudVarServer = `settings-modal_custom-cloud-var-server_hcItu`;
var _9 = `settings-modal_custom-cloud-var-server-input_OzAsG`;
export { _9 as "custom-cloud-var-server-input" };
export var customCloudVarServerInput = `settings-modal_custom-cloud-var-server-input_OzAsG`;
export var info = `settings-modal_info_K5LRo`;
export var header = `settings-modal_header_GB6qm`;
export var divider = `settings-modal_divider_Xifj4`;
export var button = `settings-modal_button_iwiuL`;
export var warning = `settings-modal_warning_v4b0C`;
export default ___CSS_LOADER_EXPORT___;
